import React from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import "./timer.scss";

const renderTime = ({ remainingTime }) => {
  const hours = Math.floor(remainingTime / 3600)
  const minutes = Math.floor((remainingTime % 3600) / 60)
  const seconds = remainingTime % 60

  let x = `${hours}:${minutes}:${seconds}`

  return (
    <div className="timer">
      <div className="value">{x}</div>
    </div>
  );
};

export default({size, duration}) => {
  return (
      <div>
        <CountdownCircleTimer
          isPlaying
          duration={duration}
          colors={[["#004777"], ["#F7B801"], ["#A30000"]]}
          onComplete={() => [true, 1000]}
         size={size}
         strokeWidth={4}
        >
          {renderTime}
        </CountdownCircleTimer>
      </div>
 
  );
}